import { render, staticRenderFns } from "./LayoutContentWithoutVerticalNavMenu.vue?vue&type=template&id=05416258&scoped=true&"
import script from "./LayoutContentWithoutVerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./LayoutContentWithoutVerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentWithoutVerticalNavMenu.vue?vue&type=style&index=0&id=05416258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05416258",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VAppBar,VImg,VMain,VSpacer})
